<template>
  <div ref="track" v-track="'c_techportal_66wjvrus'" class="community-mvp w-full">
    <div
      :class="`community-top-nav ${isCurRoute('mvp-home') ? 'home-nav' : 'other-nav'}`"
      :style="{
        backgroundImage: isCurRoute('evaluation-home')
          ?
            'url(https://p0.meituan.net/llmarena/d75908d8e5867194de8b499f319150b3525150.png)'
          :
            'linear-gradient(to right, #e5e9f7 0%, #e5e8f7 14%, #e2e5f6 45.4%, #dcdff4 65%, #dcdcf3 75%, #dbdaf1 85%, #e0dff4 90%)',
        backgroundPosition: isCurRoute('evaluation-home') ? '0 -12px' : ''
      }"
    >
      <div class="router">
        <!-- <img :src="imageSrc" alt="" class="icon" @click="jump('mvp-home')"/> -->
        <div style="cursor: pointer" class="title" @click="jump('mvp-home')">AGI-Eval</div>
        <!--  -->
        <div
          v-for="router in routerButtonMeta"
          :key="router.title"
          :class="{ 'router-button': true, 'competition-activity': true, active: isCurRoute(router.active) }"
          @click="jump(router.target, router.title)"
        >
          <img v-if="router.title === '人机竞赛'" class="file-img" src="https://p0.meituan.net/llmarena/5876fe351abd9eefc6be350b040b01fd7349.png"/>
          <span :class="{ 'text-background-clip': isCurRoute(router.active) }">{{ router.title }}</span>
        </div>
        <div class="router-button  data-studio" @click="goDataStudio('https://agi-eval.cn/agiData/home')">
          Data Studio
          <img :src="dataImageSrc" alt="" class="data-studio-img" @click="goDataStudio('https://agi-eval.cn/agiData/home')"/>
        </div>
        <div
          :class="{ 'router-button': true, 'competition-activity': true, active: isCurRoute('evaluation-home,evaluation-detail') }"
          @click="jump('evaluation-home', '评测集社区')"
        >
          <span :class="{ 'text-background-clip': isCurRoute('evaluation-home,evaluation-detail') }">评测集</span>
        </div>
        <div
          v-if="!getTopLevelDomain()"
          :class="{ 'router-button': true, 'competition-activity': true, active: isCurRoute('model-evaluation,model-evaluation-particulars') }"
          @click="jump('model-evaluation', '模型评价')"
        >
          <span :class="{ 'text-background-clip': isCurRoute('model-evaluation,model-evaluation-particulars') }">模型评价</span>
        </div>
      </div>
      <div class="top-right">
        <div class="contribution-evaluation-set flex-center" @click="visible = true">
          <span class="text-background-clip">贡献评测集</span>
        </div>
        <div class="red-dot-box">
          <img
            src="@/assets/svg/inform.svg"
            style="width: 22px; margin-right: 10px; cursor: pointer;"
            @click="goInform"
          />
          <div v-if="redDot" class="red-dot" style="transform: translateY(-2px);" />
        </div>
        <div class="loading-box no-translation-tag">
          <img
            src="https://p0.meituan.net/llmarena/32c9c4080c22847b964c35deb4b8c5741129.png"
            style="width: 22px; margin-right: 10px; cursor: pointer;"
            @click="changeLang()"
          />
          <mtd-loading v-if="langLoading" class="loading no-translation-tag" message="" size="small"/>
        </div>
        <mtd-popover ref="popover" v-model="popoverVisible" trigger="click" placement="bottom-end" :append-to-container="false">
          <i class="mtdicon mtdicon-avatar-fill avatar" @click="changeAvatar" />
          <template #content>
            <div class="avatarContent">
              <div v-for="(A, AI) in avatarList" :key="AI" class="avatarItem" @click="A.fn && A.fn()">
                {{ A.label }}
              </div>
            </div>
          </template>
        </mtd-popover>
        <!-- <i class="mtdicon mtdicon-avatar-fill avatar" @click="goPersonalCenter()" /> -->
      </div>
    </div>
    <mtd-modal v-model="visible" width="390px" class="model-contribution">
      <template #title>
        <div class="text-black text-[28px] font-medium leading-[50px]" style="text-align: center;">贡献评测集</div>
      </template>
      <div class="flex flex-col items-center ">
        <div
          class="text-[#5829fc] text-base font-normal"
          style="padding-left: 2px; color: #595959; font-size: 18px; text-align: center;"
        >
          添加小助手，贡献评测集
        </div>
        <img src="@/assets/evaluation.png" class="w-[200px] h-[200px] mt-[18px]"/>
        <div
          class="text-[#5829fc] text-2xl font-semibold leading-loose text-background-clip"
          style="font-size: 20px; margin: 10px 0"
        >
          AGI-Eval小助手
        </div>
      </div>
    </mtd-modal>
  </div>
</template>
<script lang="ts">
import { Component, Ref, Spectra, Watch, Weaver } from '@/decorators';
import Evaluation from '@/store/modules/Evaluation';
import Verification from '@/store/modules/Verification';
import { track } from '@/utils/import-all';
import { ssoURL } from '@/utils/sso';
import { changeLang } from '@/utils/translate';
import axios from 'axios';

@Component
@Spectra
export default class App extends Weaver(Evaluation, Verification) {
  @Ref('track') trackRef: any;
  @Ref('popover') popoverRef: any;
  routerButtonMeta = [
    {
      title: '评测榜单',
      target: 'mvp-top-Ranking',
      active: 'mvp-top-Ranking,mvp-list-summary-index,mvp-model-diff',
    },
    {
      title: '人机竞赛',
      target: 'competition-activity',
      active: 'competition-activity,competition-activity-detail',
    },
  ];
  avatarList = [
    {
      label: '个人主页',
      fn: this.goPersonalHomepage,
    },
    {
      label: '资料设置',
      fn: this.goPersonalCenter,
    },
    {
      label: '联系我们',
      fn: () => this.$store.commit('feedbackChange', true),
    },
    {
      label: '退出登录',
      fn: this.handelLogOut,
    },
  ];
  langLoading = false;
  visible = false;
  popoverVisible = false;
  redDot = false;

  @Watch('hasUnreadNotifications')
  hasUnreadNotificationsChange(val) {
    this.redDot = Object.values(val).some(Boolean);
  }

  getTopLevelDomain() {
    const hostnameParts = window.location.hostname.split('.');
    const topLevelDomain = hostnameParts[hostnameParts.length - 1];
    if (topLevelDomain === 'org') return true;
  }

  createIntervalApiCaller(interval, maxRetry) {
    let timer: any = null;
    let retryCount = 0;
    const execute = async () => {
      try {
        const result: any = await this.action$hasUnreadNotifications({});
        this.redDot = Object.values(result).some(Boolean);
        retryCount = 0;
        return result;
      } catch (error) {
        if (retryCount < maxRetry) {
          retryCount++;
          await new Promise((resolve) => setTimeout(resolve, 5000));
          return execute();
        }
      }
    };

    const start = () => {
      stop();
      timer = setInterval(execute, interval);
      execute();
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    return { start, stop };
  }

  apiCaller: any = null;
  async created() {
    const user = localStorage.getItem('user');
    if (user) {
      this.apiCaller = this.createIntervalApiCaller(5 * 60 * 1000, 5);
      this.apiCaller.start();
    }
  }

  beforeDestroy() {
    if (this.apiCaller) this.apiCaller.stop();
  }

  @Watch('$store.state.langLoading', { deep: true })
  langLoadingChange(val) {
    this.langLoading = val;
  }

  async goInform() {
    this.$router.push({ name: 'mvp-inform-center' });
  }

  async handelLogOut() {
    try {
      await this.action$commWebApiUserMe({});
      this.formData = {
        ...this.commWebApiUserMe.user,
        age: Number(this.commWebApiUserMe.user.age),
      };
      const obj = {
        userName: this.formData.mobileNumber || this.formData.mis,
      };

      if (!obj.userName) return;
      await axios.post(`${ssoURL}/llmSso/logout`, obj);
      document.cookie = 'access-token=; max-age=0;';
      document.cookie = 'client-id=; max-age=0;';
      localStorage.removeItem('user');
      this.popoverVisible = false;

      this.$router.push({ name: 'mvp-home' });
    } catch (e) {
      console.error(e);
      this.popoverVisible = false;
    }
  }

  formData: any = {};

  async changeAvatar() {
    await this.changeLang(true);
    setTimeout(() => {
      this.popoverRef.updatePopper();
    }, 1300);
  }

  async changeLang(flag = false) {
    await new Promise((resolve) => setTimeout(resolve, 0));
    this.$nextTick(async () => {
      await changeLang(flag);
    });
  }

  get imageSrc() {
    return this.isCurRoute('mvp-home')
      ? 'https://p0.meituan.net/llmarena/5fc91621ad2229330963418007fb7ff134140.png'
      : 'https://p0.meituan.net/llmarena/312bf2d7ad4b59e48f94f046ab17560a32914.png';
  }

  get dataImageSrc() {
    return this.isCurRoute('mvp-home')
      ? 'https://p0.meituan.net/llmarena/a794a1c704f7d79a38d337483481e1ac314.png'
      : 'https://p0.meituan.net/llmarena/91dacc5251fc478ebf4a9648b0e48a56298.png';
  }

  goDataStudio(url) {
    track(this.trackRef, 'b_techportal_80urjonw_mc');
    window.open(url);
  }

  jump(target, name?) {
    if (name === '人机比赛') {
      track(this.trackRef, 'b_techportal_o4eqfd3w_mc');
      localStorage.setItem('agi-eval-jump', 'community-top-nav');
      window.open(
        this.$router.resolve({
          name: target,
        }).href,
        '_blank'
      );
    } else {
      this.$route.name !== target && this.$router.push({ name: target });
    }
  }
  isCurRoute(target) {
    return target.includes(this.$route.name);
  }
  async goPersonalCenter() {
    try {
      this.$router.push({ name: 'mvp-personal-center' });
    } catch (error) {
      // this.$route.name !== 'mvp-login' && this.$router.push({ name: 'mvp-login' });
    }
  }

  async goPersonalHomepage() {
    try {
      this.$router.push({ name: 'mvp-personal-homepage' });
    } catch (error) {
      // this.$route.name !== 'mvp-login' && this.$router.push({ name: 'mvp-login' });
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .mtd-popover-rel {
    display: flex;
  }
  .mtd-popper-arrow {
    display: none;
  }
  .mtd-popover {
    background: transparent !important;
  }
}
.red-dot-box {
  position: relative;
}
.red-dot {
  position: absolute;
  right: 9px;
  top: 2px;
  background: red;
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
.avatarContent {
  border-radius: 6px;
  background: transparent !important;
  color: #000 !important;
  .avatarItem:first-child{
    border-radius: 8px 8px 0 0;
  }
  .avatarItem:last-child {
    border-radius: 0 0 8px 8px;
  }
}
.avatarItem {
  background: #fff;
  line-height: 36px;
  padding: 0 40px;
  cursor: pointer;
  border-bottom: 1px solid #f7f7f7;
  box-shadow: 0 2px 2px #e6d2fc;
  &::hover {
    color: #aa33ea;
  }
}
.model-contribution {
  ::v-deep {
    .mtd-modal-header {
      padding-top: 20px;
      padding-bottom: 10px;
    }
    .mtd-modal {
      min-width: 380px;
    }
  }
}
.top-right {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255);
  padding: 6px 10px;
  border-radius: 1000px;
  .avatar {
    color: #000 !important;
    font-size: 22px;
  }
  .contribution-evaluation-set {
    color: #4838f3;
    background-color: rgb(241, 240, 254);
    height: 24px;
    padding: 4px 14px;
    font-size: 14px;
    border-radius: 1000px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.loading-box {
  position: relative;
  .loading {
    position: absolute;
    inset: 0;
    transform: translateX(-6px);
  }
}
.competition-activity {
  display: flex;
  align-items: center;
  .file-img {
    width: 20px;
    height: 20px;
  }
}
.community-mvp {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  min-width: 1280px;
}
.community-top-nav {
  display: flex;
  top: 0;
  height: 60px;
  width: 100%;
  padding: 0 40px;
  align-items: center;
  justify-content: space-between;
}
.home-nav {
  color: white;
  background: #000 !important;
  line-height: 36px;
  white-space: nowrap;
  .router{
    &-button:hover {
      background-color:  #4c00ff;
      line-height: 36px;
    }
    .icon {
      width:30px;
      height:30px;
      cursor: pointer;
    }
    .title {
      font-size: 22px;
      margin-left:10px;
    }
  }
}
.other-nav {
  background-color: #fff;
  background-position: top left;
  background-size: 100%;
  background-repeat: no-repeat;
  line-height: 36px;
  white-space: nowrap;
  .router {
    height: 100%;
    .active {
      position: relative;
      line-height: 36px;
      font-weight: 999;
      // border-bottom: 3px solid transparent;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(59.67deg, #5f8aff 20.43%, #b428e7 94.21%);
        pointer-events: none; /* 确保伪元素不会干扰鼠标事件 */
      }
    }
    .router-button {
      height: 100%;
      cursor: pointer;
    }
    .icon {
      width:30px;
      height:30px;
      cursor: pointer;
    }
    .title {
      font-size: 22px;
      margin-left:10px;
    }
  }
}
.router {
  display: flex;
  align-items: center;
  &-button {
    height: 36px;
    margin-left: 30px;
    font-size: 16px;
    line-height: 36px;
    border-radius: 20px;
    padding: 0 20px;
    cursor: pointer;
    white-space: nowrap;
  }
}
.avatar {
  cursor: pointer;
  font-size: 30px;
}

.data-studio {
  display: flex;
  align-items: center;
  .data-studio-img {
    width:15px;
    height:15px;
    cursor: pointer;
    margin-left: 5px;
  }
}

</style>
